<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form
          class="box"
          ref="productForm"
          :model="product"
          label-width="100px"
        >
          <fieldset class="mgb15">
            <fieldset class="mgb15">
              <legend>
                {{ $t("text.baseInfo") }}
                <a
                  v-if="
                    product.purchaseUrl != null &&
                    product.purchaseUrl.trim() != ''
                  "
                  :href="product.purchaseUrl"
                  target="_blank"
                  >{{ $t("product.purchaseUrl") }}</a
                >
                <span class="float-right"
                  >{{ $t("product.showPrice") }}:{{
                    $t("boolean." + product.showPrice)
                  }}</span
                >
              </legend>
            </fieldset>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.productNo')">{{
                  product.productNo
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.unit')">{{
                  product.unit
                }}</el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('product.category')">{{
                  product.categoryName
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.brand')">{{
                  product.brand
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.name')" :prop="'name'">
                  {{ product.name }}
                </el-form-item>
              </el-col>
              <el-col v-if="product.isScore == true" :span="8">
                <el-form-item :label="$t('product.score')">
                  {{ product.score }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col v-if="Permit.canActions('globalSalePrice')" :span="8">
                <el-form-item :label="$t('product.salesPrice')">
                  <currency
                    :code="product.salesCurrency"
                    v-if="product.salesPrice != null"
                  ></currency
                  >{{ product.salesPrice }}</el-form-item
                >
              </el-col>
              <el-col v-if="Permit.canActions('globalSalePrice')" :span="8">
                <el-form-item :label="$t('product.depositPrice')">
                  <currency
                    :code="product.salesCurrency"
                    v-if="product.depositPrice != null"
                  ></currency
                  >{{ product.depositPrice }}</el-form-item
                >
              </el-col>
              <!-- <el-col v-if="Permit.canActions('globalCostPrice')" :span="8">
                <el-form-item :label="$t('product.costPrice')">{{
                  product.costPrice | currency
                }}</el-form-item>
              </el-col>
              <el-col v-if="Permit.canActions('globalSalePrice')" :span="8">
                <el-form-item :label="$t('product.wholeSalePrice')">{{
                  product.wholesalePrice | currency
                }}</el-form-item>
              </el-col> -->
            </el-row>
          </fieldset>
          <el-row :gutter="10">
            <el-col :span="14">
              <fieldset
                v-if="
                  product.productLabels && product.productLabels.length != 0
                "
                class="mgb15"
              >
                <legend>{{ $t("product.label") }}</legend>
                <el-tag
                  v-for="productLabel in product.productLabels"
                  :key="productLabel.name"
                  type="info"
                  >{{ productLabel.name }}</el-tag
                >
              </fieldset>
              <fieldset
                v-if="product.colors && product.colors.length != 0"
                class="mgb15"
              >
                <legend>{{ $t("product.color") }}</legend>
                <el-tag
                  v-for="color in product.colors"
                  :key="color"
                  type="info"
                  >{{ color }}</el-tag
                >
              </fieldset>
              <fieldset
                v-if="product.sizes && product.sizes.length != 0"
                class="mgb15"
              >
                <legend>{{ $t("product.size") }}</legend>
                <el-tag v-for="size in product.sizes" :key="size" type="info">{{
                  size
                }}</el-tag>
              </fieldset>
              <fieldset
                v-if="
                  product.customAttributeJson != null &&
                  product.customAttributeJson != '[]'
                "
                class="mgb15"
              >
                <legend>{{ $t("menu.attributes") }}</legend>
                <el-tag
                  v-for="customAttribute in JSON.parse(
                    product.customAttributeJson
                  )"
                  :key="customAttribute"
                  type="info"
                  >{{ customAttribute }}</el-tag
                >
              </fieldset>
              <fieldset v-if="product.introduction != null" class="mgb15">
                <legend>{{ $t("product.introduction") }}</legend>
                <raw-html :content="product.introduction" />
              </fieldset>
            </el-col>
            <el-col :span="10">
              <fieldset v-if="product.images != null" class="mgb15">
                <legend>{{ $t("product.images") }}</legend>
                <thumbnail
                  :images="product.images"
                  :list="true"
                  width="50"
                  height="auto"
                />
              </fieldset>
              <fieldset v-if="product.shopImages != null" class="mgb15">
                <legend>{{ $t("product.shopImages") }}</legend>
                <thumbnail
                  :images="product.shopImages"
                  :list="true"
                  width="50"
                  height="auto"
                />
              </fieldset>
            </el-col>
          </el-row>
          <fieldset
            v-if="
              product.productSizePrices &&
              product.productSizePrices.length != 0 &&
              (Permit.canActions('globalSalePrice') ||
                Permit.canActions('globalCostPrice'))
            "
            class="mgb15"
          >
            <legend>{{ $t("product.sizePrice") }}</legend>
            <vxe-table
              :data="product.productSizePrices"
              id="priceTable"
              row-id="id"
              ref="recordsTable"
              class="recordsTable"
              size="mini"
              resizable
              round
              highlight-hover-row
              auto-resize
              border
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column field="size" :title="$t('product.size')" />
              <vxe-table-column
                v-if="Permit.canActions('globalSalePrice')"
                field="salesPrice"
                :title="$t('product.salesPrice')"
              >
                <template v-slot="{ row }">
                  <currency
                    :code="product.salesCurrency"
                    v-if="product.salesPrice != null"
                  ></currency
                  >{{ row.salesPrice }}</template
                >
              </vxe-table-column>
              <vxe-table-column
                v-if="Permit.canActions('globalCostPrice')"
                field="costPrice"
                :title="$t('product.costPrice')"
              >
                <template v-slot="{ row }">{{
                  row.costPrice | currency
                }}</template>
              </vxe-table-column>
              <vxe-table-column
                v-if="Permit.canActions('globalSalePrice')"
                field="wholesalePrice"
                :title="$t('product.wholeSalePrice')"
              >
                <template v-slot="{ row }">{{
                  row.wholesalePrice | currency
                }}</template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtml from "@/components/RawHtml";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Attachment from "@/components/Attachment";
import Currency from "@/components/Currency";

import Product from "@/api/product.js";

export default {
  props: {
    uuid: String,
  },
  mixins: [page, table.pager, table.search, table.checker],
  components: {
    Thumbnail,
    RawHtml,
    RawHtmlLimitNumber,
    Attachment,
    Currency,
  },
  data() {
    return {
      activeName: "detail",
      product: { uuid: null },
    };
  },
  created() {
    const self = this;
    this.getProduct();
  },
  methods: {
    getProduct() {
      const self = this;
      self.loadingStart();
      Product.findByUuid({ uuid: self.uuid }).then(function (res) {
        if (res.data.code === 200) {
          self.product = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
  },
};
</script>